import type { FlowTreeNode, LinearFlowNode } from '@vk-hr-tek/ui/FlowTree';

import { EventFlow } from '@app/gen/events';

export interface EventsFlowMapper {
  convertTree(flow: EventFlow): Promise<FlowTreeNode>;

  convertLinear(flow: EventFlow): Promise<LinearFlowNode[]>;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EventsFlowMapper = Symbol('EventsFlowMapper');
